<template>
  <!-- <b-card v-if="user && (hasAnyContact || isOwner)">
    <div class="flex flex-col gap-4">
      <h2 class="text-lg font-semibold text-white">{{ t('profile_contact.title') }}</h2>

      <template v-if="hasAnyContact">
        <div class="flex justify-between items-center gap-2" v-if="user.profile?.contact_phone">
          <div class="flex items-center gap-2 min-w-0">
            <Icon name="solar:phone-bold-duotone" class="text-gray-400 shrink-0" size="1.25rem" />
            <span class="text-gray-400 shrink-0">{{ t('profile_contact.contact_phone') }}</span>
          </div>
          <span class="text-white truncate">{{ user.profile.contact_phone }}</span>
        </div>

        <div class="flex justify-between items-center gap-2" v-if="user.profile?.whatsapp">
          <div class="flex items-center gap-2 min-w-0">
            <Icon name="mdi:whatsapp" class="text-gray-400 shrink-0" size="1.25rem" />
            <span class="text-gray-400 shrink-0">{{ t('profile_contact.whatsapp') }}</span>
          </div>
          <span class="text-white truncate">{{ user.profile.whatsapp }}</span>
        </div>

        <div class="flex justify-between items-center gap-2" v-if="user.profile?.contact_email">
          <div class="flex items-center gap-2 min-w-0">
            <Icon name="solar:letter-bold-duotone" class="text-gray-400 shrink-0" size="1.25rem" />
            <span class="text-gray-400 shrink-0">{{ t('profile_contact.contact_email') }}</span>
          </div>
          <span class="text-white truncate">{{ user.profile.contact_email }}</span>
        </div>

        <div class="flex justify-between items-center gap-2" v-if="user.profile?.linkedin">
          <div class="flex items-center gap-2 min-w-0">
            <Icon name="mdi:linkedin" class="text-gray-400 shrink-0" size="1.25rem" />
            <span class="text-gray-400 shrink-0">{{ t('profile_contact.linkedin') }}</span>
          </div>
          <a :href="user.profile.linkedin" target="_blank" rel="noopener noreferrer" class="text-blue-400 hover:text-blue-300 truncate">
            {{ user.profile.linkedin }}
          </a>
        </div>
      </template>

      <p v-else class="text-gray-400 text-sm">{{ t('profile_contact.no_contact_info') }}</p>
    </div>
  </b-card> -->
</template>

<script setup lang="ts">
import BCard from "~/components/card/BCard.vue";
import { authStore } from "~/stores/auth";
import { useUserStore } from "~/stores/userStore";

const { t } = useI18n();
const userStore = useUserStore();
const auth = authStore();

const { user } = storeToRefs(userStore);
const { user: me } = storeToRefs(auth);

const isOwner = computed(() => me.value && user.value && me.value.id === user.value.id);

const hasAnyContact = computed(() => {
  const p = user.value?.profile;
  return !!(p?.contact_phone || p?.whatsapp || p?.contact_email || p?.linkedin);
});
</script>
